<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="ch00_fm03"></a><a id="page_iv"></a><strong>Also by Candace Bushnell:</strong><br/><strong><em>Sex and the City</em></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03.vue?753f108e